"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rieti": {
    "00304616": [{
      "hkey": "64dc99b8",
      "slug": "rieti",
      "name": "Rieti",
      "primary": true,
      "skipSearch": false
    }],
    "cittaducale": [{
      "hkey": "64dc99b8",
      "slug": "rieti",
      "name": "Rieti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "97ad72ed": [{
      "hkey": "64dc99b8",
      "slug": "rieti",
      "name": "Rieti",
      "primary": true,
      "skipSearch": false
    }],
    "contigliano": [{
      "hkey": "64dc99b8",
      "slug": "rieti",
      "name": "Rieti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "94afc1a6": [{
      "hkey": "64dc99b8",
      "slug": "rieti",
      "name": "Rieti",
      "primary": true,
      "skipSearch": false
    }],
    "greccio": [{
      "hkey": "64dc99b8",
      "slug": "rieti",
      "name": "Rieti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "81416d47": [{
      "hkey": "64dc99b8",
      "slug": "rieti",
      "name": "Rieti",
      "primary": true,
      "skipSearch": false
    }],
    "leonessa": [{
      "hkey": "64dc99b8",
      "slug": "rieti",
      "name": "Rieti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ae9516c0": [{
      "hkey": "c9e0878d",
      "slug": "poggio-fidoni",
      "name": "Poggio Fidoni",
      "primary": true,
      "skipSearch": false
    }],
    "p-fidoni": [{
      "hkey": "c9e0878d",
      "slug": "poggio-fidoni",
      "name": "Poggio Fidoni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "50119dc3": [{
      "hkey": "e79cddc5",
      "slug": "campoloniano",
      "name": "Campoloniano",
      "primary": true,
      "skipSearch": false
    }],
    "rieti-campoloniano": [{
      "hkey": "e79cddc5",
      "slug": "campoloniano",
      "name": "Campoloniano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "45a9d3c7": [{
      "hkey": "efd622d0",
      "slug": "campomoro",
      "name": "Campomoro",
      "primary": true,
      "skipSearch": false
    }],
    "rieti-campomoro": [{
      "hkey": "efd622d0",
      "slug": "campomoro",
      "name": "Campomoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b29941ac": [{
      "hkey": "0a55e5aa",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "rieti-centro-storico": [{
      "hkey": "0a55e5aa",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "69cabd0d": [{
      "hkey": "0a55e5aa",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "rieti-citta-giardino": [{
      "hkey": "0a55e5aa",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rieti"
    }],
    "6071cf7e": [{
      "hkey": "add44be5",
      "slug": "piazza-tevere",
      "name": "Piazza Tevere",
      "primary": true,
      "skipSearch": false
    }],
    "rieti-piazza-tevere": [{
      "hkey": "add44be5",
      "slug": "piazza-tevere",
      "name": "Piazza Tevere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0434aba5": [{
      "hkey": "ebe3a40c",
      "slug": "regina-pacis",
      "name": "Regina Pacis",
      "primary": true,
      "skipSearch": false
    }],
    "rieti-regina-pacis": [{
      "hkey": "ebe3a40c",
      "slug": "regina-pacis",
      "name": "Regina Pacis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bfccc93f": [{
      "hkey": "ebe3a40c",
      "slug": "regina-pacis",
      "name": "Regina Pacis",
      "primary": true,
      "skipSearch": false
    }],
    "rieti-viale-maraini": [{
      "hkey": "ebe3a40c",
      "slug": "regina-pacis",
      "name": "Regina Pacis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rieti"
    }],
    "9bc8452e": [{
      "hkey": "e79cddc5",
      "slug": "campoloniano",
      "name": "Campoloniano",
      "primary": true,
      "skipSearch": false
    }],
    "rieti-zona-residenziale": [{
      "hkey": "e79cddc5",
      "slug": "campoloniano",
      "name": "Campoloniano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rieti"
    }],
    "14d55038": [{
      "hkey": "64dc99b8",
      "slug": "rieti",
      "name": "Rieti",
      "primary": true,
      "skipSearch": false
    }],
    "s-rufina": [{
      "hkey": "64dc99b8",
      "slug": "rieti",
      "name": "Rieti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f625f8ba": [{
      "hkey": "f00665ee",
      "slug": "case-san-benedetto",
      "name": "Case San Benedetto",
      "primary": true,
      "skipSearch": false
    }],
    "san-benedetto": [{
      "hkey": "f00665ee",
      "slug": "case-san-benedetto",
      "name": "Case San Benedetto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "74fec2ab": [{
      "hkey": "3f4e1df2",
      "slug": "maglianello",
      "name": "Maglianello",
      "primary": true,
      "skipSearch": false
    }],
    "castel-san-benedetto-maglianello": [{
      "hkey": "3f4e1df2",
      "slug": "maglianello",
      "name": "Maglianello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "727e7e30": [{
      "hkey": "64dc99b8",
      "slug": "rieti",
      "name": "Rieti",
      "primary": true,
      "skipSearch": false
    }],
    "lugnano": [{
      "hkey": "64dc99b8",
      "slug": "rieti",
      "name": "Rieti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;